import React from 'react';
import './togglebutton.css';

const ToggleButton = ({ numbers = [14, 42, 56], renderNumber, setRenderNumber }) => {

  return (
    <div className="toggle-wrapper">
      <div className="v-label">v</div>
      <div className="toggle-container-wrap">
      <div className="toggle-container">
        {numbers.map((number, index) => (
          <div
            key={index}
            className={`label ${number === renderNumber ? 'active' : ''}`}
            onClick={() => setRenderNumber(number)}
          >
            {number}
          </div>
        ))}
      </div>
      </div>
    </div>
  );
};



export default ToggleButton;
